import zhTranslation from '../locales/zh.json';
import enTranslation from '../locales/en.json';
import { useLanguageStore, Languages } from './useLanguageStore';

const localesMap = {
  [Languages.zh]: zhTranslation,
  [Languages.en]: enTranslation,
};

export default function useI18n() {
  const { lang = Languages.zh } = useLanguageStore();
  const locales = localesMap[lang];

  return (name: keyof typeof zhTranslation) => {
    return locales?.[name] || '';
  };
}
